import './App.css';
import React, {Fragment} from 'react';
import ImageSection from './components/ImagesSection/ImageSection';
import Header from './components/Header/Header';

function App() {

  return (
    <Fragment>
      <Header/>
      <ImageSection/>
    </Fragment>
  )
}

export default App;
